module.exports = __webpack_public_path__ + "dimer/static/img/t$eImg3.97ceed0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t$eImg3.jpg
// module id = ipHS
// module chunks = 0